import React from 'react'
import { Menu } from 'antd'
import { HomeOutlined, FileTextOutlined, TeamOutlined, ReadOutlined, WalletOutlined, PoweroffOutlined, GlobalOutlined, CustomerServiceOutlined, SelectOutlined, PictureOutlined, LinkOutlined, PlaySquareOutlined, FileOutlined, FundOutlined, NodeIndexOutlined } from '@ant-design/icons'
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import classnames from 'classnames'
import { redirectTo } from 'services/router'
import { withLocation, withProfile, withSupportChat } from 'redux/enhancers'
import { showLocaleModal } from 'redux/actions/settings'
import { menuItems } from 'services/menu'
import { getLocaleData } from 'locales/utils'
import { superEgoAppURL, marketingPlanURL } from 'services/utils'

import style from './style.module.scss'

const iconsMap = {
  'home': <HomeOutlined />,
  'file-text': <FileTextOutlined />,
  'team': <TeamOutlined />,
  'book': <ReadOutlined />,
  'wallet': <WalletOutlined />,
  'link': <LinkOutlined />,
  'video': <PlaySquareOutlined />,
  'file': <FileOutlined />,
  'fund': <FundOutlined />,
  'picture': <PictureOutlined />,
  'select': <SelectOutlined />,
  'service': <CustomerServiceOutlined />,
  'language': <GlobalOutlined />,
  'logout': <PoweroffOutlined />,
  'diagnostician-materials': <NodeIndexOutlined />,
}

const MenuLeft = ({
  intl: { formatMessage },
  showLocaleModal,
  locale,
  location,
  logInReset,
  showSupportChat,
  supportChatIsReady,
  onMenuItemClick = () => {}
}) => {
  const selectedKeys = menuItems
    .filter(menuItem => menuItem.url === location.pathname)
    .map(menuItem => menuItem.key)

  const languageName = getLocaleData(locale) ? formatMessage({ id: getLocaleData(locale).name }) : '';

  const menuItemClickHandler = (url) => {
    onMenuItemClick(url);
    redirectTo(url)
  }

  return (
    <Menu
      theme="light"
      mode="inline"
      selectedKeys={selectedKeys}
      className={style.menuLeft}
    >
      {menuItems.filter(i => !i.hidden).map(menuItem => (
        <Menu.Item
          key={menuItem.key}
          onClick={() => menuItemClickHandler(menuItem.url)}
        >
          {iconsMap[menuItem.icon] || null}
          <span className="nav-text">{formatMessage({ id: menuItem.title })}</span>
        </Menu.Item>
      ))}
      <Menu.SubMenu
        title={
          <>
            {iconsMap.book}
            <span className="nav-text">{formatMessage({ id: 'menu.left.useful-materials' })}</span>
          </>
        }
        key="useful-materials"
      >
        <Menu.Item
          key="marketing-plan"
          onClick={() => window.open(marketingPlanURL)}
        >
          {iconsMap.book}
          <span className="nav-text">{formatMessage({ id: 'menu.left.marketing-plan' })}</span>
        </Menu.Item>
        <Menu.Item
          onClick={() => menuItemClickHandler('/photobank')}
          key="photobank"
        >
          {iconsMap.picture}
          <span className="nav-text">{formatMessage({ id: 'title.photobank' })}</span>
        </Menu.Item>
        <Menu.Item
          key="videobank"
          onClick={() => menuItemClickHandler('/videobank')}
        >
          {iconsMap.video}
          <span className="nav-text">{formatMessage({ id: 'title.videobank' })}</span>
        </Menu.Item>
        <Menu.Item
          key="files"
          onClick={() => menuItemClickHandler('/files')}
        >
          {iconsMap.file}
          <span className="nav-text">{formatMessage({ id: 'title.files' })}</span>
        </Menu.Item>
        <Menu.Item
          key="diagnostician-materials"
          onClick={() => menuItemClickHandler('/diagnostician-materials')}
        >
          {iconsMap["diagnostician-materials"]}
          <span className="nav-text">{formatMessage({ id: 'title.diagnostician-materials' })}</span>
        </Menu.Item>
      </Menu.SubMenu>
      <Menu.Item
        key="goto-masterkit"
        onClick={() => window.open(superEgoAppURL)}
      >
        {iconsMap.select}
        <span className="nav-text">{formatMessage({ id: 'menu.left.goto-masterkit' })}</span>
      </Menu.Item>
      <Menu.Item key="support" onClick={showSupportChat} disabled={!supportChatIsReady}>
        {iconsMap.service}
        <span className="nav-text">{formatMessage({ id: 'menu.left.support' })}</span>
      </Menu.Item>
      <div className={style.separator} key="separator-1" />
      <Menu.Item key="language" onClick={showLocaleModal}>
        {iconsMap.language}
        <span className={classnames("nav-text", style.language)}>{languageName}</span>
      </Menu.Item>
      <div className={style.separator} key="separator-2" />
      <Menu.Item key="exit" onClick={logInReset}>
        {iconsMap.logout}
        <span className="nav-text">{formatMessage({ id: 'menu.left.logout' })}</span>
      </Menu.Item>
    </Menu>
  )
}

export default connect(({ settings: { locale } }) => ({locale}), { showLocaleModal })(injectIntl(withLocation(withProfile(withSupportChat(MenuLeft)))))
